<template>
    <div>
    <!-- reset form -->
        <div v-if="!sendingMail">
            <p class="font-weight-bold pb-1 text-left">Passwort vergessen?</p>
            <p class="text-left mb-5">
                Bitte gib deine E-Mail-Adresse ein und klicke auf den Button. Du erhältst dann eine E-Mail zum Ändern des Passworts!
            </p>
            <!-- regular login -->
            <v-form ref="form" lazy-validation v-if="rules" @submit.prevent>
                <v-text-field v-model="email" label="E-Mail-Adresse"
                              :rules="[rules.required, rules.email]"
                              outlined dense clearable></v-text-field>
                <error-msg :error="errorMsg"></error-msg>
                <v-btn depressed block color="primary" @click="resetPW()">Passwort zurücksetzen</v-btn>
                <v-btn depressed block @click="close()" class="mt-5" >zurück</v-btn>
            </v-form>
        </div>
    <!-- spinner for waiting time for sign up and email creation -->
        <v-progress-circular indeterminate color="primary" v-else></v-progress-circular>
    </div>

</template>

<script>
    import {FormRules} from "../../services/formRules";
    import firebase from 'firebase/app'
    import 'firebase/auth'
    import ErrorMsg from "../../components/elements/errorMsg";

    export default {
        components: {ErrorMsg},
        name: "with-e-mail-reset-p-w",
        data: () => ({
            email: '',
            rules: null,
            sendingMail: false,
            errorMsg: '',
        }),
        created(){
            this.rules = new FormRules;
        },
        methods: {
            resetPW() {
                this.sendingMail = true;
                firebase.auth().languageCode = 'de';
                firebase.auth().sendPasswordResetEmail(this.email).then( () => {
                    this.sendingMail = false;
                    this.$emit("navigate", "login");
                }).catch( (error) => {
                    this.sendingMail = false;
                    this.errorHandling(error);
                });
            },
            errorHandling(error) {
                let i18nCode = "";
                switch (error.code) {
                    case "auth/user-not-found": i18nCode = "login.userUnkown"; break;
                    default:
                        console.log ("errorCode: ", error.code);
                        this.errorMsg = error.message;
                        return
                }
                this.errorMsg = i18nCode;
            },
            close(){
                this.$emit("navigate", "login");
            }
        }
    }
</script>

<style scoped>

</style>